module.exports = __webpack_public_path__ + "static/media/icon4.b6e20c7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon4.jpg
// module id = 132
// module chunks = 0